// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"40c36eeb","27":"935d9a9e","186":"4b85d21d","209":"350a51dc","344":"fab93e8f","372":"011dc466","377":"83532606","387":"4e518383","738":"b6c8bc12","841":"35ddfd41","856":"ca239d18","891":"af5a9389"}[chunkId] + ".chunk.js";
};